export function utcToLocal(utc: string | Date) {
    const date =
        typeof utc === 'string'
            ? new Date(/([zZ]|[+-]\d{2}(:?\d{2})?$)/.test(utc.trim()) ? utc : utc.trim() + 'Z')
            : utc;
    return date;
}

export const formatOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
};
